(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('OrderListController', OrderListController);

    OrderListController.$inject = [
        '$scope',
        'ordersService',
        '$templateCache',
        '$timeout',
        '$filter',
        'genericDataService',
        '$rootScope',
        '$window',
        'preferences',
        '$state',
		'reportService',
        'notificationService',
        'userService',
        'simpleModalService',
        '$stateParams',
        'common',
        'restrictionService'
    ];

    /* jshint maxstatements:false, maxparams:false */
    function OrderListController(
        $scope,
        ordersService,
        $templateCache,
        $timeout,
        $filter,
        genericDataService,
        $rootScope,
        $window,
        preferences,
        $state,
		reportService,
        notificationService,
        userService,
        simpleModalService, 
        $stateParams,
        common,
        restrictionService) {
        
        /* PRIVATE VARIABLES */
        var templates = {
            rowTemplate: $templateCache.get('app/views/tablesTemplates/orders/rowTemplate.html'),
            stateTemplate: $templateCache.get('app/views/tablesTemplates/orders/stateTemplate.html'),
            actionsTemplate: $templateCache.get('app/views/tablesTemplates/orders/actionsTemplate.html'),
            headerTemplate: $templateCache.get('app/views/tablesTemplates/logistics/customHeaderTemplate.html'),
            ubicacionRec: $templateCache.get('app/views/tablesTemplates/generic/ubicacionRecTemplate.html'),
            ubicacionEnt: $templateCache.get('app/views/tablesTemplates/generic/ubicacionEntTemplate.html')
        };
        var paginationOptions = {
            pageNumber: 1,
            pageSize: 25,
			sort: { field: 'date', direction: 'desc' }
        };
        var sorting = {
			field: 'date',
			direction: 'desc'
        };

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.restrictionService = restrictionService; 


        vm.onDateRangeChange = onDateRangeChange;
        vm.dateRange = $.extend({}, common.defaultDateRangePickerOptions);
        
        //Grid
        $scope.gridData = null; 
		vm.gridApi = null;
		vm.focusedRow = null;
		vm.loadingInformation = true;
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,

            enableGridMenu: true,

            paginationPageSizes: [25, 50, 75],
            paginationPageSize: 25,
            useExternalPagination: true,
            useExternalSorting: true,

            enableRowSelection: true,
            multiSelect: true,

            enableColumnResizing: true,

            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,
            virtualizationThreshold: 200,

            primaryKey: 'id',

            columnDefs: computeColumnsByOrderType(),
            data: 'gridData',
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
                vm.gridApi.grid.options.enableExpandAll= false;

                vm.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if(sortColumns.length > 0){
                        sorting.field = sortColumns[0].field;
                        sorting.direction = sortColumns[0].sort.direction;
                    }else{
                        sorting = {field: null, direction: null};
                    }
                    getOrdersData();
                });
                vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;
					getOrdersData();

                });
                vm.gridApi.core.on.columnVisibilityChanged( $scope, function( changedColumn ){
                    saveColumnsVisibilityState();
                });
            }
        };

        //Filters
        vm.appliedFilters = []; //Filters that are currently applied to the data
		var filtersJSON = null;
		vm.mostrarDadosBaja = 0;
        vm.predefinedFilter = {name: 'Personalizado', filter: null};
        vm.predefinedFilters = []; //List of predefined filters that the user saved
		vm.clientsList = [];
        //Data access methos have to be exposed here directly no namespaced
		vm.getClientsData = genericDataService.getClients;
		vm.getEmpresasData = genericDataService.getEmpresas;
        vm.statesData = preferences.prefs.orderStates;
        vm.fields =[
            //Default filters to appear
			{
				default: true, display: 'Empresa', type: 'multi', field: 'empresaId',
				getData: 'getEmpresasData', onChange: 'filterClients'
			}, 
            {default: true, display: 'Estado', type: 'multi', field: 'state', 
                data: 'statesData'},
			{ default: true, display: 'Fecha', type: 'date', field: 'date' },
            {default: true, display: 'Cliente', type: 'multi', field: 'clienteId', 
				getData: 'getClientsData', data: 'clientsList'}, 
            {default: true, display: 'Exped.', type: 'string', field: 'expedient'},
			{default: true, display: 'Matrícula', type: 'string', field: 'plate'},
			{default: true, display: 'Nº orden', type: 'string', field: 'jobOrder'},


            //Rest of possible filters
            { display: 'Programada', type: 'number', field:'programada' },
			{ display: 'Entrega', type: 'string', field: 'deliveryAddress' }, 
			{ display: 'Recogida', type: 'string', field: 'pickupTown' },
			{ display: 'Marca', type: 'string', field: 'brand' },
			{ display: 'Modelo', type: 'string', field: 'model' },
            //{display: 'Operarios', type: 'multi', field: 'operarioId', getData: genericDataService.getOperarios},
        ];
        vm.frequencyFields = computeFreqFieldsByOrderType(); 

        vm.searchText = '';
        vm.clearSearcher = clearSearcher;
        vm.filterControl = {}; //Used to call methods of the filter directive
        
        vm.reportService = reportService;
        var programadas = $stateParams.programadas; 
		vm.programada = true; 

        /* PUBLIC FUNCTIONS */
		vm.filterClients = filterClients;
        vm.getOrdersData = getOrdersData;
        vm.isFiltered = isFiltered;
        vm.selectAll = selectAll;
        vm.clearAll = clearAll;
        vm.selectOrClear = selectOrClear;
        vm.invertSelection = invertSelection;
        vm.showHideFilterBar = showHideFilterBar;
        vm.applyFilter = applyFilter;
        vm.goToEdit = goToEdit;
        vm.getBackgroundColor = getBackgroundColor;
        vm.getColorEstado = getColorEstado;
        vm.getEstadoName = getEstadoName;
        vm.changeOrderState = changeOrderState;
        vm.remove = remove;
        vm.saveFilter = saveFilter;
        vm.filterChange = filterChange; 
        vm.setPredefinedFilter = setPredefinedFilter; 
		vm.removeAllOrders = removeAllOrders;
		vm.refreshData = refreshData;
        vm.toggleDadosBaja = toggleDadosBaja;
        vm.refreshGrid = refreshGrid;
        vm.deleteFilter = deleteFilter;
        vm.getIconoOrden = getIconoOrden;
        vm.deleteSearchData = deleteSearchData;        
        
        vm.refreshing = false;
        vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('ordenes')];

        vm.goToOrdenNueva = goToOrdenNueva;
        vm.reloadListener = null;

        vm.rowCount = 0;
		vm.firstLoaded = false;

		vm.sectorName = "orden" + preferences.prefs.sector;

        /* INITIALIZER */
		(function () {
			
			var state = $rootScope.stateStorage[vm.tab.name];

			if (state && vm.tab.keepState && state.programadas === programadas) {
				vm.programada = false;
				$timeout(function () {
                    vm.searchText = state.search || '';
                    vm.mostrarDadosBaja = state.baja || false;
                    vm.focusedRow = state.focusedRow || null;
                    if (state.filters) {
                        vm.filterControl.setPredefinedFilters(state.filters);
                    }
                }, 0);
            } else {
				if ($stateParams.programadas) {
					vm.programada = false;
                    $timeout(function () {
                        var f = vm.filterControl.getFilters();
                        f.push({
                            default: false,
                            display: 'Programadas',
                            field: 'programada',
                            input1: '1',
                            operator: '=',
                            type: 'number'
                        });
                        f.push({
                            default: false,
                            display: 'Fecha',
                            field: 'date',
                            id: 'hoy',
                            type: 'date'
                        });
                        vm.filterControl.setPredefinedFilters(f);
                    }, 0);
                } else {
                    vm.getOrdersData();
                }
            }

            getPredefinedFilters();
            setColumnVisibility();

            vm.reloadListener = $rootScope.$on('ReloadOrdenes', function (event, args) {
                vm.refreshData();
            });
            
        })();

        $scope.$on('detail-resize', function (event, args) {
            if (vm.tab.isActive()) {
                $timeout(function () {
                    if (!common.isNullOrUndefined(vm.gridApi)) {
                        vm.gridApi.core.handleWindowResize();
                    }
                }, 0);
            }
        });


        /* FUNCTION DEFINITIONS */
        function getOrdersData(success) {
			vm.loadingInformation = false;
            var skip = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            var take = paginationOptions.pageSize;
            ordersService.getAllOrders(skip, take, sorting, vm.appliedFilters, vm.mostrarDadosBaja ? 1 : 0, vm.frequencyFields, vm.searchText, false, vm.dateRange.fromDate, vm.dateRange.toDate)
                .then(function (result) {
                    $scope.gridData = result.data.list;
                    vm.gridOptions.totalItems = result.data.count;                    
                    vm.rowCount = vm.gridOptions.totalItems;
                    vm.firstLoaded = true;
				    vm.refreshing = false;
				    vm.loadingInformation = true;
				    if (success) {
					    notificationService.sendAppNotification({
						    message: 'Orden eliminada con éxito',
						    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
					    });
				    }
                    //Mantain the selected row after loading the new data
                    var selected = vm.gridApi.selection.getSelectedRows();
                    vm.clearAll();
                    for(var i = 0; i < $scope.gridData.length; i++){
                        var found = $filter('filter')(selected, {'orderId':$scope.gridData[i].orderId});
                        if(found[0]){
                            vm.gridApi.grid.modifyRows($scope.gridData);
                            vm.gridApi.selection.selectRow($scope.gridData[i]);
                        } 
                    }
                });
        }

        function computeColumnsByOrderType(){ 
            if (preferences.prefs.sector === 'GRU') { 
                return [
                    {
                        field: 'state',
                        displayName: 'Estado',
                        width: '*',
                        resizable: true,
                        cellTemplate: templates.stateTemplate,
                        headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'nombreEmpresa',
						displayName: 'Empresa',
						width: '*',
						resizable: true,
						headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'jobOrder',
						displayName: 'Nº Orden',
						width: '*',
						resizable: true,
						headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'expedient',
						displayName: 'Expediente',
						width: '*',
						resizable: true,
						headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'clientName',
						displayName: 'Cliente',
						width: '*',
						resizable: true,
						headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'date',
						displayName: 'Fecha',
						width: '*',
						resizable: true,
						cellFilter: 'date: "dd/MM/yyyy HH:mm"',
						sort: { priority: 1, direction: 'desc' },
						headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'brand',
						displayName: 'Marca',
						width: '*',
						resizable: true,
						visible: false,
						headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'model',
						displayName: 'Modelo',
						width: '*',
						resizable: true,
						visible: false,
						headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'plate',
						displayName: 'Matrícula',
						width: '*',
						resizable: true,
						headerCellTemplate: templates.headerTemplate
					},
					/*{
						field: 'pickupTown',
						displayName: 'Población',
						width: '*',
						resizable: true,
						visible: false,
						headerCellTemplate: templates.headerTemplate
					},*/
					{
						field: 'pickupAddress',
						displayName: 'Dirección de recogida',
						width: '*',
						resizable: true,
                        visible: false,
                        cellTemplate: templates.ubicacionRec,
						headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'deliveryAddress',
						displayName: 'Dirección de entrega',
						width: '*',
						resizable: true,
						visible: false,
                        cellTemplate: templates.ubicacionEnt,
						headerCellTemplate: templates.headerTemplate
					},


					{
						field: 'fault',
						displayName: 'Avería',
						width: '*',
						resizable: true,
						cellFilter: 'capitalize',
						headerCellTemplate: templates.headerTemplate
					},
                    {
                        name: 'acciones',
                        displayName: 'Acciones',
                        width: 150,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.actionsTemplate,
                        enableHiding: false,
                        enableSorting: false
                    }
                ];
            }
            else if (preferences.prefs.sector === 'TAX') { 
                return [
                    {
                        field: 'state',
                        displayName: 'Estado',
                        width: '*',
                        resizable: true,
                        cellTemplate: templates.stateTemplate,
                        headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'nombreEmpresa',
						displayName: 'Empresa',
						width: '*',
						resizable: true,
						headerCellTemplate: templates.headerTemplate
					},
                    {
                        field: 'jobOrder',
                        displayName: 'Nº Orden',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'expedient',
                        displayName: 'Expediente',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'clientName',
						displayName: 'Cliente',
						width: '*',
						resizable: true,
						headerCellTemplate: templates.headerTemplate
					},
					{
						field: 'date',
						displayName: 'Fecha',
						width: '*',
						resizable: true,
						cellFilter: 'date: "dd/MM/yyyy HH:mm"',
						sort: { priority: 1, direction: 'desc' },
						headerCellTemplate: templates.headerTemplate
					},
                    {
                        field: 'plate',
                        displayName: 'Matrícula',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },

					/*{
						field: 'pickupTown',
						displayName: 'Población',
						width: '*',
						resizable: true,
						visible: false,
						headerCellTemplate: templates.headerTemplate
					},*/

                    {
                        field: 'pickupAddress',
                        displayName: 'Dirección de recogida',
                        width: '*',
                        resizable: true,
                        visible: false,
                        cellTemplate: templates.ubicacionRec,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'deliveryAddress',
                        displayName: 'Dirección de entrega',
                        width: '*',
                        resizable: true,
                        visible: false,
                        cellTemplate: templates.ubicacionEnt,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        name: 'acciones',
                        displayName: 'Acciones',
                        width: 150,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.actionsTemplate,
                        enableHiding: false,
                        enableSorting: false
                    }
                ];
            }
        }

        function computeFreqFieldsByOrderType() {
            if (preferences.prefs.sector === 'GRU') { 
				return ['expedient','plate', 'jobOrder'];
            }
            else if (preferences.prefs.sector === 'TAX') { 
				return ['expedient','plate', 'jobOrder'];
            }
        }

        /* FILTROS */
        function getPredefinedFilters(){
            //filtersJSON = userService.getFilterConfig('flotaordeneslistado'); 
            filtersJSON = $window.localStorage['filtersOrd'];

            getFiltersFromJSON();
        }

        function getFiltersFromJSON(){
            vm.predefinedFilters = angular.fromJson(filtersJSON) || [];
            angular.forEach(vm.predefinedFilters, function(value, key) {
                if (value.type === 'date') {
                    value.input1 = value.input1 && new Date(value.input1);
                    value.input2 = value.input2 && new Date(value.input2);
                }
            });
        }

        function applyFilter(filters){
            vm.appliedFilters = filters;
			getOrdersData();
        }

        function saveFilter(filterName, filters){
            //var predefinedFilters = userService.getFilterConfig('flotaordeneslistado') || []; 
            deleteFilter(filterName);

            var predefinedFilters = angular.fromJson($window.localStorage['filtersOrd']) || [];
            predefinedFilters.push({name: filterName, filter: filters});
            $window.localStorage.setItem('filtersOrd', angular.toJson(predefinedFilters));
            //userService.saveFilterConfig(predefinedFilters, 'flotaordeneslistado');

            getPredefinedFilters();
        }
        function deleteFilter(name){
            var predefinedFilters = angular.fromJson($window.localStorage['filtersOrd']) || [];
            var newFilters = predefinedFilters.filter(function( obj ) {
                return obj.name !== name;
            });
            $window.localStorage.setItem('filtersOrd', angular.toJson(newFilters));
            getPredefinedFilters();
        }
        
        function filterChange(){
            vm.predefinedFilter = {name: 'Personalizado', filter: null};
        }

		function setPredefinedFilter(selectedFilter) {
            vm.filterControl.setPredefinedFilters(selectedFilter.filter);
            
            getFiltersFromJSON();

            $timeout(function(){
                vm.predefinedFilter =  selectedFilter;
            }, 0);
        }

        $scope.$on('$destroy', function () { //Save state

            if (vm.reloadListener != null)
                vm.reloadListener();

            var filters = vm.filterControl.getFilters();

            $rootScope.stateStorage[vm.tab.name] = 
                { 
                    filters : filters, 
                    search : vm.searchText, 
                    baja : vm.mostrarDadosBaja, 
                    focusedRow: vm.focusedRow, 
                    programadas: programadas
                };
        });


        /* HIDE/SHOW COLUMS */
        function saveColumnsVisibilityState(){
            var columns = [];
            angular.forEach(vm.gridOptions.columnDefs, function(value, key) {
                columns.push({displayName: value.displayName, visible: value.visible === false? false : true});
            });
            $window.localStorage.setItem('colVisibilityOrd', angular.toJson(columns));
            //userService.saveColumnConfig(columns, 'flotaordeneslistado');
        }

        function setColumnVisibility(){
            //var columns = userService.getColumnConfig('flotaordeneslistado') || []; 
            var columns = angular.fromJson($window.localStorage['colVisibilityOrd']) || [];

            if(!columns){ return; }
            angular.forEach(vm.gridOptions.columnDefs, function(value, key) {
                var col = $filter('filter')(columns, {displayName: value.displayName})[0];
                if(col){
                    value.visible = col.visible !== false;
                }
            });
        }


        function remove(order) {
			if (!restrictionService.hasPermission('eliminar', vm.sectorName)) return; 

            if(order == null) { return; }
            simpleModalService.yesNoModal('Confirmación eliminar', '¿Desea eliminar la orden?')
                .then(function (result) {
                    if(result){
                        notificationService.sendAppNotification({
                            message: 'Eliminando ordenes...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        ordersService.removeOrders([order.id]).then(function(){
                            refreshData(true);
                        }, function(){
                            notificationService.sendAppNotification({
                                message: 'Ha ocurrido un error al eliminar las ordenes', 
                                positionY: 'top', positionX: 'right', delay: null, type:'error'});
                        });
                    }
                });
        }

		function goToEdit(order) {
			vm.focusedRow = order.id;
            restrictionService.hasPermission('modificar', vm.sectorName, 'flota.ordenes.editar', { 'id': order.id });

            //$state.go('flota.ordenes.editar', { 'id': order.id });
            //$rootScope.tabManager.goToOrdenes(order.id);
        }

        function changeOrderState(orderId, state) {
            ordersService.legacyChangeOrderState(orderId, state)
                .then(function () {
                    getOrdersData();
                });
        }

        function getBackgroundColor(order) {
            return preferences.prefs.getStateColor(order.state) || 'undefined';
        }
        function getColorEstado(state) {
            return preferences.prefs.getStateColor(state) || 'undefined';
        }
        function getEstadoName(estado) {
            return preferences.prefs.getStateDesc(estado) || 'undefined';
        }

        function isFiltered(field){
            for(var i = 0; i < vm.appliedFilters.length; i++){
                if(vm.appliedFilters[i].input != null){
                    if(vm.appliedFilters[i].field === field){
                        return true;
                    }
                }
            } 
            return false;
        }

        function getIconoOrden(tipo){
            return userService.userData.orders.iconoOrden[tipo] || 'undefined';
        }

        /* ROW SELECTION */
        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }
        function clearAll() {
            vm.gridApi.selection.clearSelectedRows();
        }
        function invertSelection(){
            var selected = vm.gridApi.selection.getSelectedRows();

            vm.selectAll();

            for(var i = 0; i < selected.length; i++){
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }
        function selectOrClear(){
            if(vm.gridApi.selection.getSelectAllState()){
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }


        function showHideFilterBar(){
            vm.filtersSidebar = !vm.filtersSidebar;
            if(!vm.filtersSidebar) { vm.filterControl.clearModifiedFilters(); }
            $rootScope.$broadcast('detail-resize');
		}

        function removeAllOrders() {
			if (!restrictionService.hasPermission('eliminar', vm.sectorName)) return; 

            simpleModalService.yesNoModal('Confirmación eliminar', 
                '¿Desea eliminar las ' + vm.gridApi.selection.getSelectedCount() + ' ordernes seleccionadas?')
                .then(function(result){
                    if(result){
                        var orderIds = [];
                        var selected = vm.gridApi.selection.getSelectedRows();
                        for (var i = 0; i < selected.length; i++) {
                            orderIds.push(selected[i].orderId);
                        }
                        notificationService.sendAppNotification({
                            message: 'Eliminando ordenes...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        ordersService.removeOrders(orderIds)
                            .then(function () {
                                refreshData(true);
                            },
                            function(){
                                notificationService.sendAppNotification({
                                    message: 'Ha ocurrido un error al eliminar las ordenes', 
                                    positionY: 'top', positionX: 'right', delay: null, type:'error'});
                        });
                    }
                });

		}

		function refreshData(success) {
			vm.refreshing = true;
			getOrdersData(success);
        }

        function clearSearcher() {
            vm.searchText = '';
            refreshData();
        }

		function toggleDadosBaja() {
            vm.mostrarDadosBaja = !vm.mostrarDadosBaja;
			getOrdersData();
		}

		function refreshGrid() {
			getOrdersData();
		}

		function filterClients() {
			vm.clientsList = [];

		}

		function deleteSearchData() {
			vm.searchText = '';
        }

        function goToOrdenNueva() {
			restrictionService.hasPermission('modificar', vm.sectorName, 'flota.ordenes.nueva');
            //$rootScope.tabManager.goToOrdenes(null);
        }

        function onDateRangeChange() {
            refreshData();
        }
    }
})();

